<template>
    <div>
        <b-alert :show="!!errorHandlingMessage" variant="danger" dismissible>{{ errorHandlingMessage }}</b-alert>
        <VendorSummary
            v-if="hasResource"
            :resource="resource"
            :hide-locations="true"
            @resource:updated="onUpdatedResource"
        />
    </div>
</template>

<script>
import { errorHandling } from '../../js/custom-vue-mixins';
import { suppliosApi } from '../../js/api-service';
import VendorSummary from '../vendors/pages/VendorSummary.vue';

export default {
    name: 'PortalCompanyProfile',
    components: {
        VendorSummary,
    },
    mixins: [
        errorHandling,
    ],
    props: {
        companyId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            errorMsg: 'Error',
            error: false,
            loading: false,
            resource: null,  // will be company data object
            resourceType: 'Vendor',  // just for compatibility
        }
    },
    computed: {
        hasResource() {
            return !!this.resource && !!this.resource.id;
        },
    },
    mounted() {
        this.getDetail();
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
        onUpdatedResource(data) {
            const resource = this.resource ? Object.assign(this.resource, data) : Object.assign({}, data);
            // make sure we have type in there for now at least...
            if (!resource.type && this.resourceType) {
                resource['type'] = this.resourceType;
            }
            this.resource = resource;
        },
        async getDetail() {
            this.loading = true;
            try {
                const response = await suppliosApi.vendorStandard.retrieve(this.companyId);
                this.onUpdatedResource(response.data);
            } catch (err) {
                this.apiErrorHandler(err, 'There was a problem getting company data');
            }
            this.loading = false;
        },
    }
}
</script>

<style>

</style>